<template>
  <div>
    <span v-if="data.column.field === 'id'">
      <div class="d-flex justify-content-start align-items-center">
        <span v-if="data.row.imageUrl != null">
          <b-avatar
            rounded
            :src="data.row.imageUrl"
            class="mr-1"
          />
        </span>
        <span v-else>
          <b-avatar
            rounded
            :text="data.row.name.charAt(0)"
            class="mr-1"
          />
        </span>
        <span>
          {{ data.row.id }}
        </span>
      </div>
    </span>

    <span v-else-if="data.column.field === 'status'">
      {{ getAccountStatus(data.row.status) }}
    </span>

    <span v-else-if="data.column.field === 'createdAt'">
      <div class="d-flex justify-content-between text-align-left">
        <span>
          {{ data.row.createdAt }}
        </span>
        <span class="d-flex">
          <b-button
            v-b-modal.modal-edit-account
            variant="link"
            class="p-0"
            @click="setAccountModel(data.row)"
          >
            <GjIcon
              name="Edit"
              class="text-primary"
            />
          </b-button>
          <b-button
            v-b-modal.modal-small-delete
            variant="link"
            class="p-0"
            @click="deleteAccount(data.row)"
          >
            <GjIcon
              name="Delete"
              class="text-danger"
            />
          </b-button>
        </span>
      </div>
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const deleteAccount = row => store.commit('SET_ACCOUNT_TO_DELETE', row)
    const accountStatuses = store.getters.getAccountStatuses
    const setAccountModel = accountModel => {
      const accModel = { ...accountModel }
      store.commit('SET_EDIT_ACCOUNT_MODEL', accModel)
    }
    const getAccountStatus = statusId => {
      const status = accountStatuses.find(x => x.value === statusId)
      if (status) return status.text
      return '-'
    }

    return {
      deleteAccount, setAccountModel, accountStatuses, getAccountStatus,
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/views/admin/management/accounts-data.scss';
</style>
